export default {
  today: 'Today',
  yesterday: 'Yesterday',
  'ticket.list.status_pending': 'New',
  'ticket.list.status_working': 'In progress',
  'ticket.list.status_closed': 'Closed',
  'ticket.list.status_unknown': 'Unknown',
  'ticket.list.id': '#%1 from %2',
  'deposit.min_msg': 'Minimum payment to account %1 %2',
  'legal_entity.status_new': 'Processing',
  'legal_entity.status_approved': 'Confirmed',
  'legal_entity.status_declined': 'Denied',
  'legal_entity.invoice.status_new': 'Processing',
  'legal_entity.invoice.paid': 'Paid',
  'access.role_managers.title': 'Administrator',
  'access.role_reporters.title': 'Observer',
  'partner_payment.status_pending': 'In progress',
  'partner_payment.status_paused': 'Pause',
  'partner_payment.status_error': 'Error',
  'partner_payment.status_success': 'Processed',
  'partner_payment.status_cancelled': 'Cancelled',
  'partner_payment.status_declined': 'Denied',
  'billing_profile.payment.method.epayments': 'Epayments',
  'billing_profile.payment.method.juridical': 'Legal Entity',
  'billing_profile.payment.method.qiwi': 'QIWI',
  'billing_profile.payment.method.paymaster': 'WebMoney',
  'billing_profile.payment.method.paymaster_ru': 'WebMoney WMP',
  'billing_profile.payment.method.paypal': 'PayPal',
  'billing_profile.payment.method.lucky': 'Lucky.online',
  'billing_profile.payment.method.stripe': 'Bank card',
  'billing_profile.payment.method.winpay': 'WinPay',
  'billing_profile.payment.method.tinkoff': 'Tinkoff',
  'billing_profile.payment.method.paymaster_service': 'Paymaster',
  'billing_profile.withdrawal.method.bank_card': 'Bank card',
  'billing_profile.withdrawal.method.webmoney': 'WebMoney',
  'billing_profile.withdrawal.method.epayments': 'Epayments',
  'billing_profile.status_new': 'In moderation',
  'billing_profile.status_pending': 'In moderation',
  'billing_profile.status_approved': 'Confirmed',
  'billing_profile.status_declined': 'Rejected',
  'payment_profile.epayments.tax_number_label': 'VAT Number',
  'payment_profile.epayments.ru_tax_number_label': 'TIN',
  'payment_profile.paymaster.tax_number_label': 'VAT Number',
  'payment_profile.paymaster.ru_tax_number_label': 'TIN',
  'payment_profile.qiwi.tax_number_label': 'VAT Number',
  'payment_profile.qiwi.ru_tax_number_label': 'TIN',
  'payment_profile.tax_number_label': 'VAT Number',
  'payment_profile.ru_tax_number_label': 'TIN',
  'invoice.status.new': 'New',
  'invoice.status.pending': 'At work',
  'invoice.status.waiting': 'Expected payment',
  'invoice.status.paid': 'Paid',
  'invoice.title': '%1 from %2',
  'invoice.title_new': 'New account',
  'invoice.title_id': 'Account Number%1',
  'payment_profile.juridical.contact_person_label': 'Contact Person',
  'payment_profile.juridical.phone_label': 'Phone No.',
  'payment_profile.juridical.email_label': 'Email address',
  'payment_profile.juridical.currency_label': 'Invoice currency',
  'payment_profile.juridical.tax_number_local_label': 'TIN',
  'payment_profile.juridical.tax_number_foreign_label': 'VAT number',
  'payment_profile.juridical.juridical_address_local_label': 'Legal Address',
  'payment_profile.juridical.juridical_address_foreign_label': 'Registered Address',
  'payment_profile.juridical.actual_address_local_label': 'Main Office or Actual Address',
  'payment_profile.juridical.actual_address_foreign_label': 'Communication Address',
  'credit.title': 'Deferred payment #%1',
  'credit.status_pending': 'Pending',
  'credit.status_approved': 'Approved',
  'credit.status_declined': 'Declined',
  'credit.status_repaid': 'Repaid',
  'yandex_subscription.campaign.budget': '%1 %2',
  'yandex_subscription.campaign.prediction': 'Approximately %1 potential customers per month',
  'yandex_subscription.campaign.benefit': 'save on',
  'yandex_subscription.campaign.budgetType_WEB_MINIMAL': 'Minimal',
  'yandex_subscription.campaign.budgetType_WEB_MAXIMAL': 'Maximum',
  'yandex_subscription.campaign.budgetType_WEB_OPTIMAL': 'Optimal',
  'yandex_subscription.campaign.budgetType_MINIMAL': 'Minimal',
  'yandex_subscription.campaign.budgetType_MAXIMAL': 'Maximum',
  'yandex_subscription.campaign.budgetType_OPTIMAL': 'Optimal',
  'yandex_subscription.campaign.budgetType_DEFAULT': 'Default',
  'yandex_subscription.campaign.duration': '%1 days (%2)',
  'yandex_subscription.promocode.apply.success': 'Successfully applied',
  'yandex_subscription.need_replenish': 'Not enough funds to launch the campaign. <a href="%1" target="_blank">Add funds</a>',
  'yandex_subscription.slow_processing': 'The campaign creation takes longer than usual, it will be added to the list of campaigns in a few minutes',
  'financial_transaction.yandexsubscription.account_error': "Error while creating an account",
  'financial_transaction.yandexsubscription.campaign_error': "failed to create ad campaign",
  'financial_transaction.yandexsubscription.deposit_error': "Failed to add funds to account balance"
}
